import { Component, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { SearchBase } from '../search-base';
import { SearchService } from '../search.service';
import { SharedFilterComponent } from './../../shared/shared-filter/shared-filter.component';
import { GoogleAnalyticsEventsService } from './../../services/google-analytics-events.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss', '../search.component.scss'],
  providers: [TitleCasePipe]
})
export class DocumentsComponent extends SearchBase implements OnInit, OnDestroy {
  domain = 'documents';
  title = 'Documents';

  @ViewChild(SharedFilterComponent)
  sharedFilterComponent: SharedFilterComponent;

  constructor(
    protected searchService: SearchService,
    protected formBuilder: FormBuilder,
    protected titlecasePipe: TitleCasePipe,
    protected googleAnalyticsService: GoogleAnalyticsEventsService,
    protected route: ActivatedRoute
  ) {
    super(searchService, formBuilder, titlecasePipe, googleAnalyticsService, route);
  }

  ngOnInit() {

    // if case-number parameter, set case-number filter:
    this.route.queryParamMap.subscribe((query: any) => {
      const proceedingNumber = query.params.proceedingNumber || null;

      if (proceedingNumber) {
        this.paramMap = {};
        this.facetMap = {};
        this.sortMap = [{ sortColumnName: 'documentFilingDate', order: 'desc' }];
        this.addFilter('proceedingNumber', proceedingNumber);
      }
    });

    if (!this.sortMap) {
      this.sortMap = [{ sortColumnName: 'documentFilingDate', order: 'desc' }];
    }

    this.init();

  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.destroy();
  }

}
